import { SupportSession } from '../../../services/supportApi';
import { cn } from '../../../lib/utils';

interface SessionStatusPanelProps {
  session: SupportSession;
  phase: 'idle' | 'searching' | 'waiting' | 'connected' | 'ended';
  onDisconnect: () => void;
  loading?: boolean;
}

export function SessionStatusPanel({ session, phase, onDisconnect, loading }: SessionStatusPanelProps) {
  const statusColor =
    session.status === 'connected'
      ? 'text-emerald-600 dark:text-emerald-400'
      : session.status === 'pending'
        ? 'text-amber-600 dark:text-amber-400'
        : 'text-[hsl(var(--muted-foreground))]';

  return (
    <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-[hsl(var(--foreground))]">Remote Session</h3>
        <span className={cn('text-sm font-medium capitalize', statusColor)}>{phase === 'waiting' ? 'Waiting for approval' : session.status}</span>
      </div>
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Mode</dt>
          <dd className="capitalize">{session.mode}</dd>
        </div>
        <div>
          <dt className="text-[hsl(var(--muted-foreground))]">Expires</dt>
          <dd>{new Date(session.expiresAt).toLocaleTimeString()}</dd>
        </div>
        <div className="col-span-2">
          <dt className="text-[hsl(var(--muted-foreground))]">Session ID</dt>
          <dd className="font-mono text-xs break-all">{session.sessionId}</dd>
        </div>
      </dl>
      {(phase === 'connected' || phase === 'waiting') && (
        <button
          type="button"
          onClick={onDisconnect}
          disabled={loading}
          className="w-full rounded-lg bg-red-600 hover:bg-red-700 text-white py-2 text-sm font-medium disabled:opacity-50"
        >
          Disconnect Session
        </button>
      )}
    </div>
  );
}
